import { useMemo, useState } from 'react';
import { useOutOfStockProps } from './types';
import { useCartContext } from './useCartContext';
import {
  computeRemovedCartLines,
  dismissSignature,
} from './useOutOfStock.helpers';

const useOutOfStock = ({ toBeRemoved }: useOutOfStockProps) => {
  const { cart, reviewLines } = useCartContext();
  const [dismissed, setDismissed] = useState<ReadonlySet<string>>(
    () => new Set(),
  );

  const removedCartLines = useMemo(
    () =>
      computeRemovedCartLines({
        toBeRemoved,
        reviewLines,
        cartLines: cart?.lines ?? [],
        dismissed,
      }),
    [toBeRemoved, reviewLines, cart?.lines, dismissed],
  );

  const hasOutOfStockItems = removedCartLines.length > 0;

  const onDismiss = (typeId: string) => {
    const item = removedCartLines.find((i) => i.line.typeId === typeId);

    if (!item) {
      return;
    }

    setDismissed((prev) => {
      const next = new Set(prev);

      next.add(dismissSignature(item));

      return next;
    });
  };

  return {
    removedCartLines,
    hasOutOfStockItems,
    toBeRemoved,
    onDismiss,
  };
};

export default useOutOfStock;
